import React from "react";
import { Icon } from "semantic-ui-react";
import "public/css/components.unsubscribed.scss";

export default function ConfirmUnsubscribed() {
    return (
        <div className='container'>
            <div className='block'>
                <Icon name='mail outline' size='massive' />
                <h2>You have been successfully unsubscribed.</h2>
                <p>You won&apos;t receive any further emails from us.</p>
            </div>
        </div>
    );
}